import React from "react";
import { apiEndpoint } from "helpers/url_helper";

import { render } from "react-dom";
// Import Highcharts
import HighchartsReact from "highcharts-react-official";
import exportingModule from "highcharts/modules/exporting"
exportingModule(Highcharts)
require("highcharts/modules/export-data.js")(Highcharts);
import Highcharts from 'highcharts/highstock';

class VehicleCount extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          VehicleCount: [],
          Violations: [],

        }
   
        this.afterChartCreated = this.afterChartCreated.bind(this);
    this.state = {
      chartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: ""
        },
        credits: {
            enabled: false
        },
  
        yAxis: {
            title: {
              text: "Vehicle Count"
            }
          },
        xAxis: {
            labels: {
              format: "{value:%b %e}"
            },
            type: "datetime",
          },
          plotOptions: {
            series: {
            },
            areaspline: {
              fillOpacity: 0.5
            }
          },
      
        rangeSelector: {
          selected: 6
      },
        series: [
          { 
            name: "Vehicle Count ",
            data: this.state.VehicleCount,
           
           color:  '#695E93',

            borderRadius:5, 
            dataGrouping: {
              enabled: false
            }  
          },
        ],
      // exporting: {
        // showTable: false
        // },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                "viewFullscreen",
                       "printChart",
                          "separator",
                          "downloadPNG",
                          "downloadJPEG",
                          "downloadPDF",
                          "downloadSVG",
                          "separator",
                          "downloadCSV",
                          "downloadXLS",
                          //"viewData",
                          ]
            }
          },
          filename:"Vehicle Count_"+new Date().toLocaleDateString()
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 2000
              }
            }
          ]
        }
      }
    };
  }
  afterChartCreated(chart) {
    if (!chart.options.chart.forExport) {
      this.internalChart = chart;
      this.forceUpdate();
    }
  }

 async componentDidUpdate(prevProps) {
   if(prevProps.props!=this.props.props){
    // can't change
    const response = await fetch(apiEndpoint+"/GetVehicleCountFromInterval", {
      
    method: 'POST',
    headers: {
        'Content-Type': 'application/json', 
    },
    body:this.props.props
  });
    console.log(response);
   if(response.body!=null && response !=undefined)
   {
  const data = await response.json();
  var VehicleCount=JSON.parse( data.VehicleCount);
  const newArrayOfObj = (VehicleCount).map(({
    "Key": x,
    "Value":y,
    ...rest
  }) => ({
    x,y,
    ...rest
  }));
  this.setState({VehicleCount:newArrayOfObj})
  if(this.internalChart.series!=undefined){
  this.internalChart.series[0].setData(newArrayOfObj);
  }
   }
   }
    
  }

  async UNSAFE_componentWillReceiveProps (props) {
    console.log(props.props)
    if(props.props!=undefined){
      // can't change
      const response = await fetch(apiEndpoint+"/GetVehicleCountFromInterval", {
      
      method: 'POST',
      headers: {
          'Content-Type': 'application/json', 
      },
      body:props.props
    });
      console.log(response);
     if(response.body!=null && response !=undefined)
     {
    const data = await response.json();
    var VehicleCount=JSON.parse( data.VehicleCount);
    const newArrayOfObj = (VehicleCount).map(({
      "Key": x,
      "Value":y,
      ...rest
    }) => ({
      x,y,
      ...rest
    }));
  this.setState({VehicleCount:newArrayOfObj})
  if(this.internalChart.series!=undefined){
  this.internalChart.series[0].setData(newArrayOfObj);
  }
     }
    }
    }
   
  render() {
    console.log(this.state.VehicleCount)
    return (
      <HighchartsReact
        style={{ height: "100%" }}
        highcharts={Highcharts}
        options={this.state.chartOptions}
        callback={this.afterChartCreated}
        constructorType={'stockChart'}
       updateArgs={[true]}
      />
    );
  }
}

export default VehicleCount;